// components/VipEditForm.jsx
import React, { useState } from "react";
import FormInput from "./FormInput";
import SubmitButton from "./SubmitButton";
import { updateVip } from "../api/vipform";
import { toast } from "react-toastify";

export default function VipEditForm({ vipData, onBack }) {
  const [vipformData, setVipformData] = useState({
    ...vipData,
    password: "", // always start empty
  });

  const handlechange = (e) => {
    const { name, value } = e.target;
    setVipformData((prev) => ({ ...prev, [name]: value }));
  };

  const handlesubmit = async (e) => {
    e.preventDefault();

    const payload = { ...vipformData };
    if (!payload.password) {
      delete payload.password;
    }

    try {
      await updateVip(vipformData.id, payload);
      toast.success("VIP updated successfully!");
      onBack();
    } catch (error) {
      console.error(error);
      toast.error("Failed to update VIP");
    }
  };

  return (
    <div className="vipedit-wrapper">
      <div className="vipedit-card">
        <div className="card-header">
          <h1>
            <i className="fas fa-user-tie"></i> Edit VIP Profile
          </h1>
          <p>Update VIP details securely and efficiently.</p>
        </div>

        <form onSubmit={handlesubmit} className="vip-form">
          <FormInput
            label="Full Name"
            name="name"
            value={vipformData.name}
            onChange={handlechange}
            isEdit={true}
          />

          <FormInput
            label="Email"
            name="email"
            value={vipformData.email}
            onChange={handlechange}
            isEdit={true}
          />

          <FormInput
            label="Username"
            name="username"
            value={vipformData.username}
            onChange={handlechange}
            isEdit={true}
          />

          <FormInput
            label="New Password (leave blank to keep current)"
            name="password"
            type="password"
            value={vipformData.password}
            onChange={handlechange}
            isEdit={true}
            placeholder="••••••••"
          />

          <FormInput
            label="Contact Number"
            name="contactno"
            value={vipformData.contactno}
            onChange={handlechange}
            isEdit={true}
          />

          <div className="button-group">
            <SubmitButton label="Update VIP" />

            <button
              type="button"
              onClick={onBack}
              className="cancel-btn"
            >
              <i className="fas fa-arrow-left"></i> Cancel & Go Back
            </button>
          </div>
        </form>
      </div>

      <style jsx>{`
        .vipedit-wrapper {
          min-height: 100vh;
          background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
          color: #e2e8f0;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 2rem 1rem;
        }

        .vipedit-card {
          width: 100%;
          max-width: 560px;
          background: rgba(30, 41, 59, 0.8);
          backdrop-filter: blur(16px);
          border-radius: 20px;
          padding: 3rem 2.5rem;
          border: 1px solid rgba(59, 130, 246, 0.3);
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4);
          transition: all 0.3s ease;
        }

        .vipedit-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 25px 50px rgba(59, 130, 246, 0.2);
        }

        .card-header {
          text-align: center;
          margin-bottom: 2.5rem;
        }

        .card-header h1 {
          font-size: 2rem;
          font-weight: 700;
          color: #60a5fa;
          margin-bottom: 0.8rem;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.8rem;
        }

        .card-header p {
          opacity: 0.85;
          font-size: 1.05rem;
        }

        .vip-form {
          display: flex;
          flex-direction: column;
          gap: 1.6rem;
        }

        .button-group {
          display: flex;
          flex-direction: column;
          gap: 1rem;
          margin-top: 2rem;
        }

        .cancel-btn {
          background: transparent;
          color: #94a3b8;
          border: 2px solid #475569;
          padding: 0.9rem 1.5rem;
          border-radius: 14px;
          font-weight: 600;
          font-size: 1rem;
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.6rem;
        }

        .cancel-btn:hover {
          background: #475569;
          color: white;
          border-color: #60a5fa;
          transform: translateY(-2px);
        }

        @media (max-width: 576px) {
          .vipedit-card {
            padding: 2rem 1.5rem;
            margin: 0 1rem;
          }

          .card-header h1 {
            font-size: 1.7rem;
          }

          .card-header p {
            font-size: 0.95rem;
          }

          .button-group {
            margin-top: 1.5rem;
          }
        }
      `}</style>
    </div>
  );
}


// import React, { useState } from "react";
// import FormInput from "./FormInput";
// import SubmitButton from "./SubmitButton";
// import { updateVip } from "../api/vipform";
// import { toast } from "react-toastify";

// export default function VipEditForm({ vipData, onBack }) {
//    // -------- INITIAL STATE --------
//    const [vipformData, setVipformData] = useState({
//      ...vipData,
//      password: "",       // always start empty
//    });
 
// // -------- INPUT CHANGE HANDLER --------
//   const handlechange = (e) => {
//     const { name, value } = e.target;
//     setVipformData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handlesubmit = async (e) => {
//     e.preventDefault();

//     // Remove password if empty
//     const payload = { ...vipformData };
//     if (!payload.password) {
//       delete payload.password;
//     }

//     try {
//       await updateVip(vipformData.id, payload);
//       toast.success("Vip updated successfully!");
//       onBack();
//     } catch (error) {
//       console.error(error);
//       toast.error("Failed to update Vip");
//     }
//   };

//   return (
//     <form onSubmit={handlesubmit}>
//       <h2>Edit VIP</h2>

//       <FormInput
//         label="Full Name"
//         name="name"
//         value={vipformData.name}
//         onChange={handlechange}
//         isEdit={true}
//       />

//       <FormInput
//         label="Email"
//         name="email"
//         value={vipformData.email}
//         onChange={handlechange}
//         isEdit={true}
//       />

//       <FormInput
//         label="Username"
//         name="username"
//         value={vipformData.username}
//         onChange={handlechange}
//         isEdit={true}
//       />

//       {/* PASSWORD FIELD (EMPTY ALWAYS ON LOAD) */}
//       <FormInput
//         label="Password"
//         name="password"
//         type="text"
//         value={vipformData.password}   // empty initially, updates normally
//         onChange={handlechange}
//         isEdit={true}
//       />


//       <FormInput
//         label="Contact No"
//         name="contactno"
//         value={vipformData.contactno}
//         onChange={handlechange}
//         isEdit={true}
//       />

     
//       <SubmitButton label="Update" />
//       <button
//         type="button"
//         onClick={onBack}
//         className="btn btn-secondary w-100 mt-3"
//       >
//         Cancel
//       </button>
//     </form>
//   );
// }

// const selectStyle = {
//   width: "100%",
//   padding: "8px",
//   marginTop: "5px",
//   borderRadius: "5px",
//   border: "1px solid #ccc",
// };
